  // Helper to safely read env vars
const getEnv = (key, defaultValue) => {
  const value = process.env[key];
  if (!value) {
    if (defaultValue !== undefined) {
      return defaultValue;
    }
    console.warn(`Environment variable '${key}' is missing!`);
    return "";
  }
  return value;
};

const URL = getEnv("REACT_APP_API_URL");
const AG_URL = getEnv("REACT_APP_AG_URL");

export const ACTIVE_SUBSCRIPTION_KEY = getEnv("REACT_APP_SUBSCRIPTION_KEY");

const GRAPHQL_URL = "/EuameGraphql/graphql";
export const DOMAIN = URL;
export const REST_API_SIGN_IN_URL = AG_URL + "/gatewayag/api/signin";
export const GRAPHQL_URI = DOMAIN + GRAPHQL_URL;
export const CUSTOMER_API_URL = `${URL}/user/`;
export const CUSTOMER_GQL_API = `${URL}/dp`;
export const generateToken = "/otpservice/token/generateToken?";

export const tenentId = "AG";
export const buId = 1;

export const AZURE_STORAGE_BLOB_URL =
  "https://euamecs01.blob.core.windows.net/content/";
export const AZURE_BLOB_SAS_TOKEN =
  "?sp=racwdl&st=2024-06-26T08:50:04Z&se=2026-06-26T16:52:04Z&spr=https&sv=2022-11-02&sr=c&sig=X3hN%2BHGJy00MW0nKlQcFxmAGbbqUWDOemqeiLHua2Yk%3D";

export const languages = {
  1: "EN",
  2: "HI",
};

// CMS Roles
export const USER_ROLES = {
  marketing: {
    id: 15,
    name: "ROLE_MARKETING",
  },
  editor: {
    id: 17,
    name: "ROLE_CMS_EDITOR",
  },
};

// All Tenants
export const TENANTS = {
  ag: {
    value: "AG",
    label: "AG",
  },
  cs: {
    value: "CS",
    label: "CS",
  },
  ce: {
    value: "CE",
    label: "CE",
  },
};

// Upload Content Type
export const CONTENT_TYPES = {
  announcement: {
    value: "announcement",
    label: "Announcement",
  },
  pushNotification: {
    value: "push_notification",
    label: "Push Notification",
  },
  inAppAlert: {
    value: "mobile_app_notification",
    label: "In App Alert",
  },
};

export const IMAGE_MIME = [
  "image/png",
  "image/jpeg",
  "image/avif",
  "image/bmp",
  "image/gif",
  "image/svg+xml",
  "image/tiff",
  "image/webp",
  "png",
  "jpeg",
  "jpg",
  ".png",
  ".jpeg",
  ".jpg",
  ".gif",
  ".bmp",
];
